const buildResellerAvatarSvg = () =>
  `<svg xmlns="http://www.w3.org/2000/svg" width="256" height="256" viewBox="0 0 256 256" fill="none">
    <defs>
      <linearGradient id="resellerBg" x1="30" y1="20" x2="220" y2="236" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FDBA74"/>
        <stop offset="1" stop-color="#F97316"/>
      </linearGradient>
    </defs>
    <rect width="256" height="256" rx="128" fill="url(#resellerBg)"/>
    <circle cx="98" cy="112" r="30" fill="#FFF7ED"/>
    <circle cx="168" cy="112" r="30" fill="#FFF7ED"/>
    <path d="M60 196C60 165 82 148 98 148C114 148 122 156 128 164C134 156 142 148 158 148C174 148 196 165 196 196" stroke="#FFF7ED" stroke-width="16" stroke-linecap="round"/>
  </svg>`

export const DEFAULT_RESELLER_AVATAR = `data:image/svg+xml;utf8,${encodeURIComponent(buildResellerAvatarSvg())}`
